import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledSectionBonusesProgramme = styled.section<{
  color?: string;
}>`
  position: relative;
  padding-top: 140px;
  padding-bottom: 140px;
  background: ${(props) => props.color};

  @media screen and (max-width: 999px) {
    padding-top: 70px;
    padding-bottom: 598px;
  }
`;
export const StyledTitle = styled(Styled.H2)`
  width: 100%;
  @media screen and (min-width: 768px) {
    width: 50%;
  }
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 30px;
  position: relative;
  z-index: 2;

  &:after {
    position: absolute;
    top: 300%;
    left: -25%;
    display: block;
    content: "";
    width: 301px;
    height: 301px;
    border-radius: 50%;
    background: #da811b;
    opacity: 0.2;
    filter: blur(100px);
    z-index: -1;
  }
  &:before {
    position: absolute;
    top: 800%;
    right: -50%;
    display: block;
    content: "";
    width: 303px;
    height: 303px;
    border-radius: 50%;
    background: #009846;
    opacity: 0.2;
    filter: blur(100px);
    z-index: -1;
  }

  @media screen and (min-width: 768px) {
    gap: 24px;
    margin-top: 70px;
    &:before {
      position: absolute;
      top: 0;
      right: -50%;
      display: block;
      content: "";
      width: 303px;
      height: 303px;
      border-radius: 50%;
      background: #009846;
      opacity: 0.2;
      filter: blur(100px);
      z-index: -1;
    }
    &:after {
      position: absolute;
      top: -140%;
      left: -10%;
      display: block;
      content: "";
      width: 301px;
      height: 301px;
      border-radius: 50%;
      background: #da811b;
      opacity: 0.2;
      filter: blur(100px);
      z-index: -1;
    }
  }
  @media screen and (max-width: 768px) {
    overflow-x: hidden;
  }
  @media screen and (min-width: 1000px) {
    justify-content: flex-start;
  }
`;

export const ButtonApp = styled.button`
  outline: none;
  border-radius: 6px;
  border: 1px solid ${EColors.neutral_700};
  width: 100%;
  height: 100%;
  background: transparent;
  transition: all 0.3s linear;
  cursor: pointer;
  @media screen and (min-width: 768px) {
    width: 201px;
    height: 59px;
  }
  &:hover {
    border: 1px solid ${EColors.accent_300};
  }
`;
export const ImageApplication = styled.img`
  width: 100%;
  height: 100%;
`;
export const StyledImageWrapper = styled(Styled.Half)`
  position: relative;
`;
export const ImageBarCode = styled.img`
  position: absolute;
  max-width: 303px;
  max-height: 619px;
  z-index: 5;
  @media screen and (max-width: 999px) {
    top: 68px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  @media screen and (min-width: 1000px) {
    max-width: 391px;
    max-height: 798px;
    top: -150px;
    right: 24px;
  }
  @media screen and (min-width: 1200px) {
    top: -290px;
    right: 24px;
  }
  @media screen and (min-width: 1440px) {
    right: 199px;
  }
`;
export const StyledContainerWrapper = styled(Styled.ContainerWrapper)`
  @media screen and (max-width: 999px) {
    gap: 0;
  }
`;
